import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/grupos/';

const formatter = (data) => {
  if (Array.isArray(data)) {
    return data.map(formatter);
  }
  return {
    ...data,
    key: data.id,
    name: data.name.split('-').shift().trim(),
  };
};
/**
 * GET Grupos
 * @returns {Promise<Array<object>>}
 */
export const getGrupos = async () => {
  try {
    const response = await API.get(baseURI);
    return formatter(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Grupo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getGrupo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatter(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Grupo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postGrupo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Grupo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchGrupo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Grupo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteGrupo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
